export const contextStubFunction = (name: string, method: string) => () => {
  throw new Error(
    `${name}Context function '${method}' was called outside of a provider scope. Are you missing a <${name}Context.Provider>?`,
  );
};
